/* eslint-disable extra-rules/no-commented-out-code */
import useInjectReducerAndSaga from '@tcp/core/src/utils/useInjectReducerAndSaga';

export default async () => {
  const [LoginPageReducer, LoginPageSaga] = await Promise.all([
    import(/* webpackChunkName: "login-page" */ './LoginPage.reducer'),
    import(/* webpackChunkName: "login-page" */ './LoginPage.saga'),
  ]);
  useInjectReducerAndSaga(
    { key: 'LoginPageReducer', reducer: LoginPageReducer.default },
    { key: 'LoginPageSaga', saga: LoginPageSaga.default }
  );
  return null;
};
